export default "__VITE_ASSET__BJ8E7BYP__";